import { render, staticRenderFns } from "./ExaminationBowelCleanseForms.vue?vue&type=template&id=a2c2ce7a"
import script from "./ExaminationBowelCleanseForms.vue?vue&type=script&lang=js"
export * from "./ExaminationBowelCleanseForms.vue?vue&type=script&lang=js"
import style0 from "./ExaminationBowelCleanseForms.vue?vue&type=style&index=0&id=a2c2ce7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports